var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrequestLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(172,33)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 85.942374,38.235294 c 6.687404,0 9.376775,3.368389 9.376775,10.59902 0,8.85728 -2.107089,12.342157 -9.376775,12.342157 h -38.2828 V 38.235294 Z M 133.19018,0 C 136.95416,0 140,3.1180809 140,6.9576844 V 97.03586 C 140,100.87479 136.95416,104 133.19018,104 H 47.905757 V 82.344434 h 48.874655 c 18.230248,0 25.133628,-8.668359 25.649508,-30.166844 0.0138,-0.864751 0.0389,-1.746986 0.0389,-2.657463 0,-15.14458 -3.18222,-24.279609 -12.37773,-29.214609 C 104.67733,17.42279 97.365466,16.703957 87.363537,16.703957 H 21.631734 V 104 H 6.8170057 C 3.05411,104 0,100.87479 0,97.03586 V 6.9576844 C 0,3.1180809 3.05411,0 6.8170057,0 Z",
    style: {
      fill: "#FFF"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrequestLogo);
export default __webpack_public_path__ + "static/media/PrequestLogo.ad6b0b12.svg";
export { ForwardRef as ReactComponent };